import { Container, Group, Text, Title, ActionIcon } from "@mantine/core";
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandTiktok,
} from "@tabler/icons-react";
import { AppAddress, AppName } from "../../lib/data";
import "./styles.scss";

export default function Footer() {
  const socialLinks = [
    {
      icon: IconBrandFacebook,
      href: "https://web.facebook.com/people/Virel-Nigeria/pfbid0qkBeuU6apiFfD17nypKcKXUPrPoZZAgvD4f9DsW7HTHczzzdnmXc6XZRgZsAj19Fl/",
      label: "Facebook",
    },
    {
      icon: IconBrandInstagram,
      href: "https://www.instagram.com/virelng",
      label: "Instagram",
    },
    {
      icon: IconBrandTiktok,
      href: "https://www.tiktok.com/@virel.nigeria",
      label: "TikTok",
    },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer-background">
        <div className="footer-orb orb-1"></div>
        <div className="footer-orb orb-2"></div>
      </div>

      <Container size="xl" className="footer-container">
        <div className="footer-main">
          {/* Brand Column */}
          <div className="brand-column">
            <div className="footer-logo">
              <img src="/icon.png" alt="Logo" width={32} height={32} />
              <span className="logo-text">{AppName}</span>
            </div>
            <Text className="tagline">
              Turning digital participation into real-world momentum.
            </Text>
            <Text size="sm" c="dimmed" mt="sm" style={{ maxWidth: 300, lineHeight: 1.5 }}>
              {AppAddress}
            </Text>
            <Group gap="sm" className="social-links">
              {socialLinks.map((link) => (
                <ActionIcon
                  key={link.label}
                  component="a"
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  size="lg"
                  radius="xl"
                  variant="subtle"
                  className="social-icon"
                  aria-label={link.label}
                >
                  <link.icon size={20} stroke={1.5} />
                </ActionIcon>
              ))}
            </Group>
          </div>

          {/* Links Columns */}
          <div className="links-group">
            <div className="links-column">
              <Title order={5} className="column-title">
                Platform
              </Title>
              <div className="footer-link-list">
                <a href="/download" className="footer-link">
                  Download
                </a>
                <a href="/#how-it-works" className="footer-link">
                  How It Works
                </a>
                <a href="/#features" className="footer-link">
                  Features
                </a>
                <a href="/#faq" className="footer-link">
                  FAQ
                </a>
              </div>
            </div>

            <div className="links-column">
              <Title order={5} className="column-title">
                Legal
              </Title>
              <div className="footer-link-list">
                <a href="/terms" className="footer-link">
                  Terms & Conditions
                </a>
                <a href="/legal" className="footer-link">
                  Legal Documents
                </a>
                <a href="/delete" className="footer-link">
                  Delete Account
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="company-attribution">
            <span className="attribution-text">Virel is a product of</span>
            <span className="company-name">Nakuzisa Group Limited</span>
            <span className="rc-number">RC9227522</span>
          </div>
          <Text size="sm" className="copyright">
            © {currentYear} {AppName}. All rights reserved.
          </Text>
        </div>
      </Container>
    </footer>
  );
}
